import { auth, authShared } from '../../config-firebase/firebase'
import { signInWithCustomToken, signOut } from 'firebase/auth'
import store from '../store'
import toast from "./toast";
import router from './router'

const getUserId = () => {
  return store.getters.user_uid
}

const getDisplayName = () => {
  return store.getters.user_displayName;
}

const signInUserWithToken = async (token) => {
  // usato solo per login fantapazz e developer
  // console.log('signInUserWithToken', token)
  try {
    // await signOutUser()
    await signInWithCustomToken(authShared, token)
    await signInWithCustomToken(auth, token)
  } catch (error) {
    console.log(error.message);
    return false
  }
  return true
}

// const signInUser = (token) => {
//   return new Promise((resolve, reject) => {
//     firebase.auth.signInWithCustomToken(token)
//       .then((firebaseUserWithDetails) => {
//         let firebaseUser = firebaseUserWithDetails.user
//         // https://stackoverflow.com/questions/58460464/firebase-realtime-database-sharding-rules
//         firebase.authShared.updateCurrentUser(firebaseUser)
//         return firebaseUser
//       })
//       .then((firebaseUser) => {
//         // authHistory nn esiste su fantapazz al momento
//         console.log('XXXXXXX')
//         if(firebase.authHistory){
//           console.log('YYYYYYY')
//           firebase.authHistory.updateCurrentUser(firebaseUser)
//         }
//         return firebaseUser
//       })
//       .then((firebaseUser) => {
//         //salva user nello store
//         store.dispatch("setUser", firebaseUser);
//         resolve(firebaseUser)
//       })
//       .catch((err) => {
//         console.log('signInUser', err)
//         reject(err)
//       })
//   })
// }

const signOutUser = async () => {
  // console.log('signOutUser')
  await signOut(authShared)

  if (authShared.name !== auth.name) {
    await signOut(auth)
  }

}

// const logoutUser = () => {
//   firebase.auth.signOut().then(() => {
//     // Sign-out successful.
//     store.commit(types.USER_CLR);
//     window.location.reload()
//   }, (error) => {
//     // An error happened.
//     console.log(error)
//     window.location.reload()
//   })
// }

export default {
  signInUserWithToken,
  signOutUser,
  getUserId,
  getDisplayName,
}